import axios, { setAuthHeader } from "../utils/axios";

const apiUrl = process.env.REACT_APP_AUTH_API_URL;

const microsoftWorkNestTokenExchange = async (microsoftToken) => {
  setAuthHeader(microsoftToken.idToken);

  try {
    const worknestTokenResponse = await axios.get(`${apiUrl}/token/microsoft`);

    return handleWorkNestTokenResponse(worknestTokenResponse);
  } catch (e) {
    return Promise.reject();
  }
};

const googleWorkNestTokenExchange = async (googleToken) => {
  setAuthHeader(googleToken);

  try {
    const worknestTokenResponse = await axios.get(`${apiUrl}/token/google`);

    return handleWorkNestTokenResponse(worknestTokenResponse);
  } catch (e) {
    return Promise.reject();
  }
};

const handleWorkNestTokenResponse = (worknestTokenResponse) =>
  worknestTokenResponse.token;

const getImpersonationToken = (email) =>
  axios.get(`${apiUrl}/token/impersonate/${email}`);

const tokenService = {
  microsoftWorkNestTokenExchange,
  googleWorkNestTokenExchange,
  getImpersonationToken,
};

export default tokenService;
